<!--
 * @Author: dengyaxin dengyaxin@xiaokunkeji.com
 * @Date: 2023-12-07 09:33:17
 * @LastEditors: dengyaxin dengyaxin@xiaokunkeji.com
 * @LastEditTime: 2023-12-16 16:32:03
 * @FilePath: /web-shop/src/pages/record/year.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <section class="record-list">
    <div class="time">
      <slot name="top"></slot>
    </div>
    <div class="statistics">
      <div class="block" v-for="(item, index) in tabList" :key="index">
        <img :src="item.icon" alt="" />
        <div>
          <p :class="['count', index === 'orderAmountSum' ? 'count1' : '']">
            {{ item.num }}
          </p>
          <span class="sub">{{ item.text }}</span>
        </div>
      </div>
    </div>
    <section class="list" v-if="dataList.length">
      <template v-if="isDay">
        <div v-for="(item, index) in dataList" :key="index" class="list-item list-item1">
          <section class="top top1">
            <div class="left">
              <div class="one">{{ item.title }}</div>
            </div>
            <div class="right">
              <span class="status" :style="{'color':item.orderStatus==='ORDER_FINISH'?'#09090A':'#C6C6C6'}">{{ item.statusText }}</span>
            </div>
          </section>
          <section class="top">
            <div class="left">
              <div class="two">核销时间：{{ item.date }}</div>
            </div>
            <div class="right" :style="{'display':item.orderStatus==='ORDER_FINISH'?'inline-flex':'none'}">
              <img src="https://res.xiaokunkeji.cn/image/2023/12/14/ecd76c8196a542bc8b6af3207c3e5ed8.png" alt="" class="add-icon" />
              <span class="price">{{ item.price }}</span>
            </div>
          </section>
            <slot name="tips" :obj="{...item,index}"></slot>
        </div>
      </template>
      <template v-else>
        <div v-for="(item, index) in dataList" :key="index" class="list-item">
          <div class="left">
            <div class="one">{{ item.date }}</div>
          </div>
          <div class="right" @click="goPage(item)">
            <span class="num">{{ item.count }}笔</span>
            <span class="price">{{ item.price }}</span>
            <img src="https://res.xiaokunkeji.cn/image/2023/12/14/096dd766f8974f66a751cf0664a9b04b.png" alt="" class="right-arrow" />
          </div>
        </div>
      </template>
    </section>
    <van-empty v-if="dataList.length === 0 " description="暂无数据" />
  </section>
</template>

<script>
// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
export default {
  props: {
    dataList: {
      type: Array,
      default: [],
    },
    tabList: {
      type: Object,
      default: {},
    },
    isDay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    goPage(row) {
      console.log(row, "nnnnn");
      this.$emit("goPage", row);
    },
  },
};
</script>
<style lang="less" scoped>
.record-list {
  margin-top: -13.3rem;
  padding: 0 0.75rem;

  .time {
    height: 1.4rem;
    font-size: 1rem;
    font-weight: 500;
    color: #fff;
    line-height: 1.17rem;
    margin-bottom: 1.55rem;
  }

  .statistics {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 3.7rem;
    margin-bottom: 0.75rem;

    .block {
      display: inline-flex;
      width: 8.25rem;
      background: linear-gradient(to bottom right, #dfecff 0%, #ffffff 100%);
      border-radius: 0.4rem 0.4rem 0.4rem 0.4rem;
      // border: 0.05rem solid #FFFFFF;
      padding: 0.75rem;
      justify-content: flex-start;
      align-items: center;

      >img {
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 0.75rem;
      }

      .count {
        height: 1.05rem;
        font-size: 0.9rem;
        font-weight: 600;
        color: #09090a;
        line-height: 1.05rem;
        margin-bottom: 0.3rem;
      }

      .count1::after {
        content: "元";
        height: 0.85rem;
        font-size: 0.6rem;
        color: #333333;
        line-height: 0.7rem;
        margin-left: 0.1rem;
      }

      .sub {
        height: 0.85rem;
        font-size: 0.6rem;
        color: #333333;
        line-height: 0.7rem;
      }
    }
  }

  .list {
    background: #ffffff;
    box-shadow: 0rem 0.1rem 0.5rem 0rem #f8f9fb;
    border-radius: 0.4rem;
    padding: 0 0.75rem;
    position: relative;

    .list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.75rem 0;
      border-bottom: 0.05rem solid #f7f7f7;
      font-size: 0.7rem;
      line-height: 0.82rem;

      .left {
        .one::before {
          content: "";
          display: inline-block;
          color: #176df9;
          width: 0.1rem;
          height: 0.6rem;
          background: #176df9;
          border-radius: 1.75rem 1.75rem 1.75rem 1.75rem;
          vertical-align: -0.03rem;
          margin-right: 0.25rem;
        }
      }

      .right {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .num {
          &::after {
            content: "|";
            margin: 0 0.25rem 0 0.2rem;
            line-height: 0.82rem;
          }
        }

        .price {
          color: #176df9;

          &::before {
            content: "¥";
            margin-right: 0.2rem;
          }
        }

        .right-arrow {
          width: 0.5rem;
          height: 0.5rem;
          margin-left: 0.25rem;
        }

        .add-icon {
          width: 0.5rem;
          height: 0.5rem;
          margin-right: 0.2rem;
        }
      }
    }

    .list-item1 {
      display: block;
      margin-left: 0.75rem;

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left{
          .one{
            margin-bottom: 0;
          }
          
        }
      }
      .top1{
        margin-bottom: 0.4rem;
        .status{
          font-size: 0.6rem;
          color: #09090A;
          line-height: 0.7rem;
        }
      }

      .left {
        .one {
          height: 1rem;
          font-size: 0.7rem;
          font-weight: 600;
          color: #000000;
          line-height: 0.82rem;
          margin-bottom: 0.4rem;

          &::before {
            margin-right: 0.75rem;
            margin-left: -0.75rem;
          }
        }

        .two {
          height: 0.85rem;
          font-size: 0.6rem;
          color: #333333;
          // line-height: 0.7rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/record/components/list.vue